/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentEventSortFieldName } from '../../models/agent-event-sort-field-name';
import { AgentsEventsPaginatedList } from '../../models/agents-events-paginated-list';
import { SortDirection } from '../../models/sort-direction';

export interface SearchAgentsEvents$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the event date
 *   * TYPE : the event type
 *   * SUBTYPE : the event type
 *   * CONNECTION_TYPE : the related connection type
 *   * CONNECTION_NAME : the related connection name
 */
  sortFieldName?: AgentEventSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search agent events
     */
    body?: any
}

export function searchAgentsEvents$Any(http: HttpClient, rootUrl: string, params?: SearchAgentsEvents$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentsEventsPaginatedList>> {
  const rb = new RequestBuilder(rootUrl, searchAgentsEvents$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentsEventsPaginatedList>;
    })
  );
}

searchAgentsEvents$Any.PATH = '/agents/events/search';
